import React, { Fragment, useCallback } from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  Filter,
  TextInput,
  TopToolbar,
  CreateButton,
  ReferenceField,
} from "react-admin";
import { Route, useHistory } from "react-router-dom";
import { Drawer } from "@material-ui/core";

import BindingCompanyCreate from "./BindingCompanyCreate";
import BindingCompanyEdit from "./BindingCompanyEdit";

import { Roles } from "../../utils/enums";
import { FormGeneral } from "../../styles/FormGeneral";

const Filters = (props) => (
  <Filter {...props} variant="outlined">
    <TextInput
      label="Buscar por nombre"
      source="businessName"
      resettable
      alwaysOn
    />
  </Filter>
);

const Actions = ({ permissions, basePath }) => (
  <TopToolbar>
    {permissions === Roles.admin && <CreateButton basePath={basePath} />}
  </TopToolbar>
);

const BindingCompanyList = ({ permissions, ...props }) => {
  const classes = FormGeneral();
  const history = useHistory();

  const handleClose = useCallback(() => {
    history.push("/person-company-bindings");
  }, [history]);

  return (
    <Fragment>
      <List
        filters={<Filters />}
        bulkActionButtons={permissions === Roles.admin ? undefined : false}
        sort={{ field: "id", order: "DESC" }}
        actions={<Actions permissions={permissions} />}
        perPage={25}
        {...props}
      >
        <Datagrid>
          <TextField source="id" />
          <TextField source="documentNumber" />
          <TextField source="businessName" />
          <ReferenceField source="trustId" reference="trusts">
            <TextField source="name" />
          </ReferenceField>
          {permissions === Roles.admin && <EditButton />}
        </Datagrid>
      </List>
      {permissions === Roles.admin && (
        <Route path="/person-company-bindings/create">
          {({ match }) => (
            <Drawer
              open={!!match}
              anchor="right"
              onClose={handleClose}
              classes={{ root: classes.drawerIndex }}
            >
              <BindingCompanyCreate
                className={classes.drawerContent}
                onCancel={handleClose}
                {...props}
              />
            </Drawer>
          )}
        </Route>
      )}
      {permissions === Roles.admin && (
        <Route path="/person-company-bindings/:id">
          {({ match }) => {
            const isMatch = !!(
              match &&
              match.params &&
              match.params.id !== "create"
            );

            return (
              <Drawer
                open={isMatch}
                anchor="right"
                onClose={handleClose}
                classes={{ root: classes.drawerIndex }}
              >
                {isMatch ? (
                  <BindingCompanyEdit
                    className={classes.drawerContent}
                    id={match.params.id}
                    onCancel={handleClose}
                    {...props}
                  />
                ) : (
                  <div className={classes.drawerContent} />
                )}
              </Drawer>
            );
          }}
        </Route>
      )}
    </Fragment>
  );
};

export default BindingCompanyList;
